import {
  Typography,
  TypographyProps as MuiTypographyProps,
} from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface NoResultsTextProps {
  contentType?: string;
  TypographyProps?: MuiTypographyProps;
}

export default function NoResultsText({
  contentType,
  TypographyProps,
}: Readonly<NoResultsTextProps>) {
  const { t } = useTranslation();

  const text = useMemo(() => {
    if (contentType) {
      return t('content.noResultsForContentType', {
        contentType: t(`contentType.${contentType}`, { context: 'some' }),
      });
    }

    return t('articles.noContent');
  }, [contentType, t]);

  return <Typography {...TypographyProps}>{text}</Typography>;
}
